import React from "react";
import Navbar from "./brochure/Navbar";
import Hero from "./brochure/Hero";
import Overview from "./brochure/Overview";
import Learn from "./brochure/Learn";
import Features from "./brochure/Features";
import Tools from "./brochure/Tools";
import Curriculum from "./brochure/Curriculum";
import Projects from "./brochure/Projects";
import Internship from "./brochure/Internship";
import Placement from "./brochure/Placement";
import MockInterview from "./brochure/MockInterview";
import Careers from "./brochure/Careers";
import Included from "./brochure/Included";
import Certifications from "./brochure/Certifications";
import CourseFee from "./brochure/CourseFee";
import Footer from "./brochure/Footer";

export default function Brochure() {
  return (
    <div className="grain relative min-h-screen overflow-x-hidden bg-[#EEF1F8] text-[#293891]" data-testid="brochure-page">
      <Navbar />
      <main className="relative z-10">
        <Hero />
        <Overview />
        <Learn />
        <Features />
        <Tools />
        <Curriculum />
        <Projects />
        <Internship />
        <Placement />
        <MockInterview />
        <Careers />
        <Included />
        <Certifications />
        <CourseFee />
      </main>
      <Footer />
    </div>
  );
}
